// import React, { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import * as Constants from '../../Constant/constant';
// import './Announcement.css';
// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';

// const AddAnnouncement = () => {
//   const [form, setForm] = useState({
//     title: '',
//     description: '', 
//     desc_img: '', // This is used for the image in the description
//     announcement_date: '',
//     library_id: '',
//   });

//   const [libraries, setLibraries] = useState([]);
//   const [previewImage, setPreviewImage] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [successMsg, setSuccessMsg] = useState('');
//   const [errorMsg, setErrorMsg] = useState('');
//   const [showSuccessModal, setShowSuccessModal] = useState(false);

//   // Use a ref for the toolbar container
//   const toolbarRef = useRef(null);

//   const handleChange = e => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const handleDescriptionChange = (event, editor) => {
//     const data = editor.getData();
//     setForm({ ...form, description: data });
//   };

//   const handleSubmit = async e => {
//     e.preventDefault();
//     setLoading(true);
//     setSuccessMsg('');
//     setErrorMsg('');
//     setShowSuccessModal(false);

//     try {
//       const res = await axios.post(Constants.API_PATH + '/announcements-create', form);
//       setSuccessMsg(res.data.message || 'Announcement created.');
//       setShowSuccessModal(true);
//       await sendEmailsToUsers(form.title, form.description, form.announcement_date, form.library_id);
//       setForm({ title: '', description: '', desc_img: '', announcement_date: '', library_id: '' });
//     } catch (error) {
//       setErrorMsg(error.response?.data?.error || 'Failed to create announcement.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     const fetchLibraries = async () => {
//       try {
//         const res = await axios.get(Constants.API_PATH + '/add_new_library_data');
//         setLibraries(res.data);
//       } catch (error) {
//         setErrorMsg('Failed to fetch libraries.');
//       }
//     };
//     fetchLibraries();
//   }, []);

//   const handleCloseModal = () => {
//     setShowSuccessModal(false);
//   };

//   class MyUploadAdapter {
//     constructor(loader) {
//       this.loader = loader;
//     }
  
//     // Starts the upload process.
//     upload() {
//       return this.loader.file.then(file => {
//         const data = new FormData();
//         data.append('file', file);
  
//         return fetch(Constants.API_PATH +'/send-announcement-mail-admin', {
//           method: 'POST',
//           body: data
//         })
//           .then(response => response.json())
//           .then(result => ({
//             default: result.url // image URL returned from your server
//           }));
//       });
//     }
  
//     abort() {
//       // Optional: abort upload logic
//     }
//   }
  

//   const sendEmailsToUsers = async (title, description, desc_img, announcement_date, library_id) => {
//     try {
//       await axios.post(Constants.API_PATH + '/send-announcement-mail', {
//         title,
//         description,
//         desc_img,
//         announcement_date,
//         library_id,
//       });
//     } catch (error) {
//       console.error('Error sending emails:', error);
//     }
//   };

//   // For DecoupledEditor, you need to manually mount the toolbar
//   const editorInit = (editor) => {
//     if (toolbarRef.current) {
//       toolbarRef.current.innerHTML = ''; // Clear previous toolbar(s)
//       toolbarRef.current.appendChild(editor.ui.view.toolbar.element);
//     }
//   };

//   return (
//     <div className="book-list-container containernew">
//       <h2>Add Announcement</h2>
//       {successMsg && <div className="alert success">{successMsg}</div>}
//       {errorMsg && <div className="alert error">{errorMsg}</div>}
//       <form onSubmit={handleSubmit} className="form">
//         <label>Title</label>
//         <input
//           type="text"
//           name="title"
//           value={form.title}
//           onChange={handleChange}
//           required
//         />

//         <label>Description</label>
//         <div ref={toolbarRef} />
//         <CKEditor
//   editor={DecoupledEditor}
//   data={form.description}
//   onReady={editor => {
//     editor.ui.getEditableElement().parentElement.classList.add('ckeditor-container');

//     // Register upload adapter
//     editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
//       return new MyUploadAdapter(loader);
//     };

//     editorInit(editor); // your existing logic
//   }}
//   onChange={handleDescriptionChange}
// />

//         {/* <CKEditor
//           editor={DecoupledEditor}
//           data={form.description}
//           onReady={editorInit}
//           onChange={handleDescriptionChange}
//         /> */}

//         <label>Announcement Image</label>
//         <input
//   type="file"
//   name="desc_img"
//   onChange={e => {
//     const file = e.target.files[0];
//     setForm({ ...form, desc_img: file });

//     if (file) {
//       setPreviewImage(URL.createObjectURL(file));
//     } else {
//       setPreviewImage(null);
//     }
//   }}
//   accept="image/*"
//   placeholder="Upload Image"
//   style={{
//     padding: '10px',
//     border: '1px solid #ccc',
//     borderRadius: '5px',
//     cursor: 'pointer',
//   }}
//   title="Upload Image"
//   required
// />

// {previewImage && (
//   <div style={{ marginTop: '10px' }}>
//     <strong>Preview:</strong>
//     <img
//       src={previewImage}
//       alt="Preview"
//       style={{ maxWidth: '100%', height: 'auto', marginTop: '5px', border: '1px solid #ccc', borderRadius: '5px' }}
//     />
//   </div>
// )}

      


//         <label>Announcement Date</label>
//         <input
//           type="date"
//           name="announcement_date"
//           value={form.announcement_date}
//           onChange={handleChange}
//           required
//         />

//         <label>Library</label>
//         <select
//           name="library_id"
//           value={form.library_id}
//           onChange={handleChange}
//           required
//         >
//           <option value="">Select Library</option>
//           {libraries.map(lib => (
//             <option key={lib.id || lib.library_id} value={lib.id || lib.library_id}>
//               {lib.name || lib.library_name}
//             </option>
//           ))}
//         </select>

//         <button type="submit" disabled={loading}>
//           {loading ? 'Sending...' : 'Create & Send'}
//         </button>
//       </form>

//       {showSuccessModal && (
//         <div className="modal">
//           <div className="modal-content">
//             <span className="close" onClick={handleCloseModal}>&times;</span>
//             <h2>Success</h2>
//             <p>{successMsg}</p>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AddAnnouncement;




import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import * as Constants from '../../Constant/constant';
import './Announcement.css';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import SearchableSelect from '../../shared/SearchableSelect';

const AddAnnouncement = () => {
  const [form, setForm] = useState({
    title: '',
    description: '',
    desc_img: null,
    announcement_date: '',
    library_id: '',
  });

  const [libraries, setLibraries] = useState([]);
  const [previewImage, setPreviewImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const toolbarRef = useRef(null);

  // Fetch libraries
  useEffect(() => {
    const fetchLibraries = async () => {
      try {
        const res = await axios.get(Constants.API_PATH + '/add_new_library_data');
        setLibraries(res.data);
      } catch (error) {
        setErrorMsg('Failed to fetch libraries.');
      }
    };
    fetchLibraries();
  }, []);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleDescriptionChange = (event, editor) => {
    const data = editor.getData();
    setForm({ ...form, description: data });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setSuccessMsg('');
    setErrorMsg('');
    setShowSuccessModal(false);

    try {
      const formData = new FormData();
      formData.append('title', form.title);
      formData.append('description', form.description);
      formData.append('announcement_date', form.announcement_date);
      formData.append('library_id', form.library_id);
      if (form.desc_img) formData.append('desc_img', form.desc_img);

      const res = await axios.post(Constants.API_PATH + '/announcements-create', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      setSuccessMsg(res.data.message || 'Announcement created.');
      setShowSuccessModal(true);

      // Send email with attachment
      await sendEmailsToUsers(formData);

      setForm({
        title: '',
        description: '',
        desc_img: null,
        announcement_date: '',
        library_id: ''
      });
      setPreviewImage(null);

    } catch (error) {
      setErrorMsg(error.response?.data?.error || 'Failed to create announcement.');
    } finally {
      setLoading(false);
    }
  };

  // 👇 Send full FormData to mail endpoint
  const sendEmailsToUsers = async (formData) => {
    try {
      await axios.post(Constants.API_PATH + '/send-announcement-mail-admin', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
    } catch (error) {
      console.error('Email Error:', error.response?.data || error.message);
    }
  };

  const handleCloseModal = () => {
    setShowSuccessModal(false);
  };

  class MyUploadAdapter {
    constructor(loader) {
      this.loader = loader;
    }

    upload() {
      return this.loader.file.then(file => {
        const data = new FormData();
        data.append('file', file);

        return fetch(Constants.API_PATH + '/upload-image-editor', {
          method: 'POST',
          body: data
        })
        .then(response => response.json())
        .then(result => ({ default: result.url }));
      });
    }

    abort() {}
  }

  const editorInit = (editor) => {
    if (toolbarRef.current) {
      toolbarRef.current.innerHTML = '';
      toolbarRef.current.appendChild(editor.ui.view.toolbar.element);
    }
  };

  return (
    <div className="book-list-container containernew">
      <h2>Add Announcement</h2>
      {successMsg && <div className="alert success">{successMsg}</div>}
      {errorMsg && <div className="alert error">{errorMsg}</div>}

      <form onSubmit={handleSubmit} className="form">
        <label>Title</label>
        <input type="text" name="title" value={form.title} onChange={handleChange} required />

        <label>Description</label>
        <div ref={toolbarRef} />
        <CKEditor
          editor={DecoupledEditor}
          data={form.description}
          onReady={editor => {
            editor.ui.getEditableElement().parentElement.classList.add('ckeditor-container');
            editor.plugins.get('FileRepository').createUploadAdapter = loader => new MyUploadAdapter(loader);
            editorInit(editor);
          }}
          onChange={handleDescriptionChange}
        />

        <label>Announcement Image</label>
        <input
          type="file"
          name="desc_img"
          // onChange={e => {
          //   const file = e.target.files[0];
          //   setForm({ ...form, desc_img: file });
          //   setPreviewImage(file ? URL.createObjectURL(file) : null);
          // }}

           onChange={e => {
    const file = e.target.files[0];
    setForm({ ...form, desc_img: file });

    // Preview only if it's an image
    if (file && file.type.startsWith("image/")) {
      setPreviewImage(URL.createObjectURL(file));
    } else {
      setPreviewImage(null);
    }
  }}

          accept="image/*,application/pdf"
          placeholder="Upload"
          style={{
            padding: '10px',
            border: '1px solid #ccc',
            borderRadius: '5px',
            cursor: 'pointer',
          }}
          required
        />

        {previewImage && (
          <div style={{ marginTop: '10px' }}>
            <strong>Preview:</strong>
            <img src={previewImage} alt="Preview" style={{ maxWidth: '100%', border: '1px solid #ccc' }} />
          </div>
        )}

        <label>Announcement Date</label>
        <input type="date" name="announcement_date" value={form.announcement_date} onChange={handleChange} required />

        <label>Library</label>
        <SearchableSelect
          name="library_id"
          value={form.library_id}
          onChange={handleChange}
          options={libraries.map(lib => ({
            value: lib.id || lib.library_id,
            label: lib.name || lib.library_name
          }))}
          placeholder="Select Library"
          required
          clearable={false}
        />

        <button type="submit" disabled={loading}>
          {loading ? 'Sending...' : 'Create & Send'}
        </button>
      </form>

      {showSuccessModal && (
        <div className="modal">
          <div className="modal-content">
            <span className="close" onClick={handleCloseModal}>&times;</span>
            <h2>Success</h2>
            <p>{successMsg}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddAnnouncement;
